import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeTenantFeature } from '../../api/queries';

export const useRemoveTenantFeatureMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      tenantId,
      feature,
    }: {
      tenantId: number;
      feature: string;
    }) => removeTenantFeature(tenantId, feature),
    onSuccess: (_, variables) => {
      // Invalidate and refetch tenant features
      queryClient.invalidateQueries({
        queryKey: ['GET_TENANT_FEATURES', variables.tenantId],
      });
    },
  });
};
